import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.spacing(1),
    color: "#000",
  },
  error: {
    color: "red",
  },
}));

export default useStyles;
